module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/widgets/notes-display/notes-display.component.scss
// module id = ./src/app/shared/components/widgets/notes-display/notes-display.component.scss
// module chunks = main